const { getRoundedNumber } = require('./getRoundedNumber');

exports.getHundredth = (number) => {
  return getRoundedNumber(number, 2);
};
